import { FC } from "react";
import { IDriverSearchTimeStats } from "../../../models/statistcs/respons";
import OrderStatusStatsCard from "../order-status-stats-card";

interface IProps {
  stats?: IDriverSearchTimeStats;
  onChange: (stats: IDriverSearchTimeStats) => void;
  hideDateControls?: boolean;
}

const timeColumns = [
  { labelKey: "orders", field: "orderCount", width: 110 },
  {
    labelKey: "average",
    field: "averageDriverSearchMinutes",
    format: "minutes" as const,
    width: 140,
  },
  {
    labelKey: "median",
    field: "medianDriverSearchMinutes",
    format: "minutes" as const,
    width: 140,
  },
  {
    labelKey: "p90",
    field: "p90DriverSearchMinutes",
    format: "minutes" as const,
    width: 140,
  },
  {
    labelKey: "p95",
    field: "p95DriverSearchMinutes",
    format: "minutes" as const,
    width: 140,
  },
  { labelKey: "drivers_notified", field: "driversNotifiedCount", width: 150 },
  { labelKey: "driver_accepted", field: "driverAcceptedCount", width: 140 },
  { labelKey: "driver_rejected", field: "driverRejectedCount", width: 140 },
  { labelKey: "driver_no_answer", field: "driverNoAnswerCount", width: 150 },
  { labelKey: "trip_assigned", field: "tripAssignedCount", width: 130 },
];

const DriverSearchTimeStats: FC<IProps> = ({
  stats,
  onChange,
  hideDateControls,
}) => (
  <OrderStatusStatsCard
    stats={stats}
    onChange={onChange}
    hideDateControls={hideDateControls}
    titleKey="driver_search_time_stats"
    averageLabelKey="average_driver_search_time"
    averageField="averageDriverSearchMinutes"
    includedField="includedOrderCount"
    includedLabelKey="included_orders"
    excludedField="excludedOrderCount"
    excludedTooltipKey="excluded_driver_search_orders_tooltip"
    metrics={[
      {
        labelKey: "candidate_completed_orders",
        field: "candidateCompletedOrderCount",
      },
      { labelKey: "legacy_combined", field: "legacyCombinedCount" },
      { labelKey: "tracked_driver_search", field: "trackedDriverSearchCount" },
      { labelKey: "median", field: "medianDriverSearchMinutes", format: "minutes" },
      { labelKey: "p90", field: "p90DriverSearchMinutes", format: "minutes" },
      { labelKey: "drivers_notified", field: "driverNotificationCount" },
      { labelKey: "driver_accepted", field: "driverAcceptedCount" },
      { labelKey: "driver_rejected", field: "driverRejectedCount" },
      { labelKey: "driver_no_answer", field: "driverNoAnswerCount" },
      { labelKey: "trip_assigned", field: "tripAssignedCount" },
    ]}
    tables={[
      {
        key: "areas",
        labelKey: "areas",
        rows: (value) => value.areas || [],
        rowKey: (row, index) => `area-${row.areaId ?? index}`,
        columns: [{ labelKey: "area", field: "areaName", width: 220 }, ...timeColumns],
      },
    ]}
  />
);

export default DriverSearchTimeStats;
